import styled from "styled-components";

import MainNavButton from "../MainNav/Button";

export const BuildingsDropdownButton = styled(MainNavButton)``;
